<template>
  <div class="n_continer">
    <div class="n_content">
      <div class="n_top">总支出：¥24.17 总收入：¥24.22</div>
      <div class="n_tab">
        <p
          v-for="(item,index) in tabs"
          :key="item"
          :class="index == cur ? 'n_active' : 'n_noactive'"
          @click="tabsSelectFg(index)"
        >{{item}}</p>
      </div>
      <div class="n_list">
        <div class="n_card n_flex" v-for="i in list" :key="i">
          <div>
            <p class="n_cardSom">{{i.change_type == 5 ? '提现' : '目前没有'}}</p>
            <p class="n_time">{{i.status}}</p>
          </div>
          <div class="n_nuim">{{i.is_inr == 1 ? '+' : '-'}}{{i.change_amount}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabs: ['全部', '支出', '收入'],
      cur: 0,
      list: [],
      page: 1,
      count: {}, //总数统计
    }
  },
  created() {
    this.getList()
    this.getCount()
  },
  mounted() {
    this.prohibitweixinShare()
  },
  methods: {
    // tab切换
    tabsSelectFg(tindex) {
      this.list = []
      this.cur = tindex
      this.getList()
    },
    //获取列表
    async getList() {
      let res = await this.http('ClientOrder.balanceChangeList', {
        page: this.page,
        type: this.cur,
      })
      this.list = res.content.list
    },
    //积分统计
    async getCount() {
      let res = await this.http('ClientScore.getUserScoreStatics', {})
      console.log(res)
    },
  },
}
</script>
<style lang="scss" scoped>
.n_continer {
  width: 100vw;
  height: 100vh;
  background: #f8f8f8;
}
.n_content {
  padding: 32px 20px;
}
.n_tab {
  display: flex;
  justify-content: space-around;
  background: rgba(255, 255, 255, 1);
  padding: 24px 0;
  border-radius: 14px;
  margin-top: 30px;
}
.n_tab p {
  position: relative;
}
.n_noactive {
  font-size: 28px;
  color: #969799;
}
.n_active {
  font-size: 28px;
  color: #323233;
}
.n_active::after {
  content: '';
  position: absolute;
  width: 80px;
  height: 6px;
  bottom: -22px;
  left: -10px;
  background: red;
  transition: width 2s;
}
.n_card {
  background: #ffffff;
  border-radius: 14px;
  padding: 27px 30px;
  margin-top: 30px;
}
.n_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.n_time {
  font-size: 22px;
  color: #969799;
  margin-top: 34px;
}
.n_cardSom {
  font-size: 32px;
  color: #323233;
}
.n_nuim {
  font-size: 38px;
  color: #333333;
}
</style>